import React, { useEffect, useState } from "react";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import { mapLoaderConfig } from "../../../GeoLocationCompoents/Services/mapLoaderConfig";
import RoughPropertyService from "../../Service/RoughPropertyService";

const containerStyle = {
  width: "100%",
  height: "400px",
};

// Utility: safely parse coordinates
const parseCoordinates = (coordString) => {
  if (!coordString) return null;
  
  try {
    const [lat, lng] = coordString.split(",").map((c) => parseFloat(c.trim()));
    if (isNaN(lat) || isNaN(lng)) return null;

    // More flexible coordinate validation (not just India)
    if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return null;

    return { lat, lng };
  } catch (error) {
    console.error("Error parsing coordinates:", coordString, error);
    return null;
  }
};

const MapWithPropertyAndData = ({ propertyInfo }) => {
  const { isLoaded } = useJsApiLoader(mapLoaderConfig);
  const [mapData, setMapData] = useState([]);

  const fetchMapData = async () => {
    try {
      const response = await RoughPropertyService.getPropertyMapPoints();
      // Handle both nested data and direct response structures
      const geoPoints = response?.data?.geoPoints || response?.geoPoints || [];
      console.log("Fetched geo points:", geoPoints);
      setMapData(geoPoints);
    } catch (error) {
      console.error("Error fetching map data:", error);
    }
  };

  useEffect(() => {
    fetchMapData();
  }, []);

  if (!isLoaded) {
    return (
      <div className="w-full h-full flex items-center justify-center text-gray-400 bg-gray-100">
        Loading map...
      </div>
    );
  }

  // Selected property marker
  const selectedProperty = propertyInfo?.geoLocation
    ? {
        id: "selected-property",
        name: propertyInfo?.name || "Selected Property",
        coordinates: propertyInfo.geoLocation,
        isSelected: true,
      }
    : null;

  // Combine all markers
  const combinedMarkers = [
    ...(selectedProperty ? [selectedProperty] : []),
    ...mapData,
  ];

  // Filter out invalid coordinates and add debugging
  const validMarkers = combinedMarkers
    .map((p, index) => {
      const coords = parseCoordinates(p.coordinates);
      const marker = {
        ...p,
        coords,
        key: p.id || `marker-${index}`,
      };
      
      if (coords) {
        console.log("Valid marker:", marker.name, coords);
      } else {
        console.warn("Invalid coordinates for:", p.name, p.coordinates);
      }
      
      return marker;
    })
    .filter((p) => p.coords);

  console.log("Total valid markers:", validMarkers.length);

  // Use first valid marker as center (if none → map will render blank)
  const center = validMarkers.length > 0 ? validMarkers[0].coords : { lat: 13.0827, lng: 80.2707 }; // Default to Chennai center

  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={center}
      zoom={validMarkers.length > 1 ? 6 : 12}
      options={{ disableDefaultUI: false }}
    >
      {validMarkers.map((property) => (
        <Marker
          key={property.key}
          position={property.coords}
          title={`${property.name} - ${property.location || ''} (${property.overallArea || ''})`}
          icon={
            property.isSelected
              ? "http://maps.google.com/mapfiles/ms/icons/green-dot.png"
              : "http://maps.google.com/mapfiles/ms/icons/red-dot.png"
          }
        />
      ))}
    </GoogleMap>
  );
};

export default MapWithPropertyAndData;
